import DateKit from '@/utils/date-kit'

const dateFilter = {
  /**
   * 功能描述：格式化时间字段
   * 使用方式：
   * {{item.date | fmtDate}}
   * {{row.createAt | fmtDate('yyyy-MM-dd')}}
   * @param value
   * @param format
   * @returns {*}
   */
  formatDate (value, format = 'yyyy-MM-dd HH:mm:ss') {
    if (!value) {
      return ''
    }

    return DateKit.format(new Date(Date.parse(value.replace(/-/g, '/'))), format)
  },

  // 全局安装器
  install (Vue) {
    Vue.filter('fmtDate', this.formatDate)
  }
}

export default dateFilter



// WEBPACK FOOTER //
// ./src/filters/date-format.js